import { gql } from "@apollo/client";

export const COLLABORATORS_QUERY = gql`
  query Collaborators($projectId: ID!) {
    collaborators(projectId: $projectId) {
      email
      githubId
      id
      verified
    }
  }
`;

export const INVITE_COLLABORATOR_MUTATION = gql`
  mutation Mutation($email: String!, $githubId: String!, $projectId: ID!) {
    inviteProjectCollaborator(email: $email, githubId: $githubId, projectId: $projectId) {
      id
    }
  }
`;

export const REMOVE_COLLABORATOR_MUTATION = gql`
  mutation RemoveProjectCollaborator($projectId: ID!, $userId: ID!) {
    removeProjectCollaborator(projectId: $projectId, userId: $userId) {
      id
    }
  }
`;
